<eo-base-form-control
  [styleClass]="getStyleClass()"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [hidden]="isHidden()"
  [canBeNotApplicable]="canBeNotApplicable"
  [notApplicableLabel]="notApplicableLabel"
  [notApplicable]="notApplicable"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <span class="w-full" [ngClass]="getInputIconPos()">
    <i *ngIf="hasInputIcon()" [class]="getInputIcon()"></i>
    <input
      *ngIf="notNumber()"
      pInputText
      attr.aria-describedby="{{ id }}-help"
      class="w-full {{ getInputStyleClass() }}"
      [id]="id"
      [tabindex]="getTabIndex()"
      [pKeyFilter]="getPKeyFilter()"
      [type]="getType()"
      [placeholder]="getPlaceholder()"
      [formControl]="getFormControl()"
      (change)="change.emit($event)"
      (focus)="focus.emit($event)"
      (blur)="blur.emit($event)"
    />

    <p-inputNumber
      *ngIf="isNumber()"
      [mode]="getMode()"
      styleClass="w-full"
      attr.aria-describedby="{{ id }}-help"
      class="w-full {{ getInputStyleClass() }}"
      locale="el-GR"
      [minFractionDigits]="getMinFractionDigits()"
      [id]="id"
      [tabindex]="getTabIndex()"
      [pKeyFilter]="getPKeyFilter()"
      [placeholder]="getPlaceholder()"
      [formControl]="getFormControl()"
      (change)="change.emit($event)"
      (focus)="focus.emit($event)"
      (blur)="blur.emit($event)"
    />
  </span>
</eo-base-form-control>
